<script setup lang="ts">
import type { Tutor } from '@brighterly/lib-core-types/tutor/interfaces'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { AppText } from '@shared/ui/typography'
import { IconContainer } from '@shared/ui/other'

import { useAttendanceRateLabel } from '../model/use-attendance-rate-label.hook'

defineOptions({
  name: 'AttendanceRateLabel',
})

const props = defineProps<{
  tutor: Tutor
}>()

const { refStatus } = useAttendanceRateLabel({ tutor: props.tutor })
</script>

<template>
  <div :class="['attendance-rate-label', refStatus.color]">
    <IconContainer>
      <FontAwesomeIcon :icon="refStatus.icon" />
    </IconContainer>
    <AppText name="body2">
      {{ refStatus.value }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./AttendanceRateLabel.scss" />
